"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "date-choose-box",
    on: {
      click: function click($event) {
        _vm.calendarShow = true;
      }
    }
  }, [_c("van-field", {
    attrs: {
      placeholder: "开始时间"
    },
    model: {
      value: _vm.startDate,
      callback: function callback($$v) {
        _vm.startDate = $$v;
      },
      expression: "startDate"
    }
  }), _c("span", [_vm._v("—")]), _c("van-field", {
    attrs: {
      placeholder: "结束时间"
    },
    model: {
      value: _vm.endDate,
      callback: function callback($$v) {
        _vm.endDate = $$v;
      },
      expression: "endDate"
    }
  })], 1), _c("van-calendar", {
    ref: "calendar",
    attrs: {
      "min-date": _vm.minDate,
      color: "#2E6CF6",
      type: "range"
    },
    model: {
      value: _vm.calendarShow,
      callback: function callback($$v) {
        _vm.calendarShow = $$v;
      },
      expression: "calendarShow"
    }
  }, [_c("template", {
    slot: "footer"
  }, [_c("div", {
    staticClass: "bottom"
  }, [_c("van-button", {
    attrs: {
      round: ""
    },
    on: {
      click: _vm.resetDate
    }
  }, [_vm._v("重置日期")]), _c("van-button", {
    attrs: {
      round: "",
      type: "info",
      color: "#2E6CF6"
    },
    on: {
      click: _vm.onConfirm
    }
  }, [_vm._v("确定")])], 1)])], 2)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;